import Header from "./components/organisms/Header/Header";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

//認証系
import { Amplify, Auth, Hub } from "aws-amplify";
import { Authenticator, Flex, translations } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { I18n } from "aws-amplify";

//自動ドアFTスマートキーオペレーター
import AalOperatorContractorListPage from "./components/pages/aal-operator/ContractorListPage";
import AalOperatorContractorFormPage from "./components/pages/aal-operator/ContractorFormPage";
import AalOperatorDoorListPage from "./components/pages/aal-operator/DoorListPage";
import AalOperatorDoorSettingsPage from "./components/pages/aal-operator/DoorSettingsPage";
import AalOperatorBuildingListPage from "./components/pages/aal-operator/BuildingListPage";
import MasterKeyQrPage from "./components/pages/aal-operator/MasterKeyQrPage";
import AalOperatorDoorLogPage from "./components/pages/Log/OperatorAALLogPage";

//フルテックアプリ
import FulltechBuildingListPage from "./components/pages/door-vendor-fulltech/BuildingListPage";
import FulltechBuildingRegistrationPage from "./components/pages/door-vendor-fulltech/BuildingRegistrationPage";
import FulltechBuildingEditPage from "./components/pages/door-vendor-fulltech/BuildingEditPage";
import FulltechOwnerListPage from "./components/pages/door-vendor-fulltech/OwnerListPage";
import FulltechOwnerRegistrationPage from "./components/pages/door-vendor-fulltech/OwnerRegistrationPage";
import FulltechOwnerEditPage from "./components/pages/door-vendor-fulltech/OwnerEditPage";
import FulltechDoorListPage from "./components/pages/door-vendor-fulltech/DoorListPage";
import FulltechDoorRegistrationPage from "./components/pages/door-vendor-fulltech/DoorRegistrationPage";
import FulltechDoorEditPage from "./components/pages/door-vendor-fulltech/DoorEditPage";
import FulltechAALLogPage from "./components/pages/Log/SDCAdminAALLogPage";
import FulltechAlertLogPage from "./components/pages/Log/SDCVenderAlertLogPage";
import FulltechBillingInformationPage from "./components/pages/door-vendor-fulltech/BillingInformationPage";

//ドアオーナーが使うオペレーター管理アプリ
import OwnerBuildingListPage from "./components/pages/owner/BuildingListPage";
import OwnerBuildingEditPage from "./components/pages/owner/BuildingEditPage";
import OwnerOperatorListPage from "./components/pages/owner/OperatorListPage";

//ハウディが使う管理アプリ
import HaudiSDCListPage from "./components/pages/sdc-vendor/SDCListPage";
import HaudiSDCEditPage from "./components/pages/sdc-vendor/SDCEditPage";
import { useState, useEffect } from "react";
import HaudiAALLogPage from "./components/pages/Log/SDCAdminAALLogPage";

//自動ドアFTスマートキーオペレーター
import SciOperatorBuildingListPage from "./components/pages/sci-operator/BuildingListPage";
import SciOperatorDoorListPage from "./components/pages/sci-operator/DoorListPage";
import SciOperatorDoorSettingsPage from "./components/pages/sci-operator/DoorSettingsPage";
import SciOperatorDoorLogPage from "./components/pages/Log/OperatorSCILogPage";
import SciOperatorAssistanceMonitorPage from "./components/pages/sci-operator/AssistanceMonitorPage";

import jwtDecode from "jwt-decode";
import { Box, CircularProgress } from "@mui/material";
import {
  MaintainanceOngoingPage,
  MaintainanceOngoingPageProps,
} from "./components/pages/MaintainanceOngoingPage";
import {
  AppVariants,
  documentTitleOf,
  domainNameOf,
  favIconPathOf,
  localDebugAddressOf,
  userGroupsOf,
} from "./common/AppVariants";
import NewOtaPage from "./components/pages/sdc-vendor/NewOtaPage";
import { OtaListPage } from "./components/pages/sdc-vendor/OtaListPage";
import NotFoundPage from "./components/pages/NotFoundPage";

/**
 * メンテナンス中はこちらを編集する。
 * nullを設定すると正常動作、MaintainanceOngoingPagePropsオブジェクトを
 * 設定するとあらゆるURLへのアクセスがメンテナンス画面表示となる。
 * @example {
 *   type: 'urgent',
 *   due: new Date('2024-07-17T12:00:00.000+09:00'),
 * }
 */
const maintainanceState: MaintainanceOngoingPageProps | null = null;

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USERPOOL_ID, // 作成したuser-poolのIDを記入
    userPoolWebClientId: process.env.REACT_APP_COGNITO_USERPOOL_CLIENT_ID, // 作成したアプリケーションクライアントのIDを記入
  },
});

// 日本語化
I18n.putVocabularies({
  ja: {
    ...translations.ja,
    "Incorrect username or password.": "ユーザー名またはパスワードが違います",
    "User does not exist.": "ユーザーが存在しません",
    "User is not confirmed.": "ユーザーが確認されていません",
    // ユーザー名とパスワードはあってるけどアプリが違う場合無理エラーをスローした後に、サインアウト処理を行うのでエラーメッセージ上はユーザーに分からないようにした。
    "Access Token has been revoked": "ユーザー名またはパスワードが違います",
  },
});
I18n.setLanguage("ja");

// パスワード忘れた処理が載っているフッターを削除
const components: any = {
  SignIn: {
    Footer() {
      return undefined;
    },
  },
};

// タブのタイトルを変更
function changeTitleFor(variant: AppVariants) {
  document.title = documentTitleOf(variant);
}

// タブのアイコンを変更
function changeFaviconFor(variant: AppVariants) {
  let favicon = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
  if (!favicon) {
    favicon = document.createElement("link");
    favicon.rel = "icon";
    document.head.appendChild(favicon);
  }
  favicon.href = favIconPathOf(variant);
}

function App() {
  const domain = window.location.hostname;
  console.log("ドメイン名" + domain);
  const port =
    window.location.port ||
    (window.location.protocol === "https:" ? "443" : "80");
  console.log("ポート" + port);
  const Url = domain + ":" + port;
  console.log("ドメイン＋ポート" + Url);

  const [isAuthenticated, setIsAuthenticated] = useState<any>("");
  const [isLoading, setIsLoading] = useState(true);

  const isUserInGroup = (
    decodedToken: { [x: string]: string | any[] },
    variant: AppVariants
  ) => {
    const groups = decodedToken["cognito:groups"];
    if (groups.length === undefined || groups.length === 0) {
      throw new Error(
        "The cognito:groups value in the given JWT is invalid. Maybe the " +
          "Cognito user has been set up manually?"
      );
    }
    return userGroupsOf(variant).some((g) => {
      return groups.includes(g);
    });
  };

  const checkAuthentication = async () => {
    setIsLoading(true);
    try {
      const session = await Auth.currentSession();
      const idToken = session.getIdToken();
      const decodedToken: any = jwtDecode(idToken.getJwtToken());

      if (
        (Url === localDebugAddressOf(AppVariants.AutolockOperator) ||
          domain === domainNameOf(AppVariants.AutolockOperator)) &&
        isUserInGroup(decodedToken, AppVariants.AutolockOperator)
      ) {
        changeTitleFor(AppVariants.AutolockOperator);
        changeFaviconFor(AppVariants.AutolockOperator);
        setIsAuthenticated(true);
        return true;
      } else if (
        (Url === localDebugAddressOf(AppVariants.Fulltech) ||
          domain === domainNameOf(AppVariants.Fulltech)) &&
        isUserInGroup(decodedToken, AppVariants.Fulltech)
      ) {
        changeTitleFor(AppVariants.Fulltech);
        changeFaviconFor(AppVariants.Fulltech);
        setIsAuthenticated(true);
        return true;
      } else if (
        (Url === localDebugAddressOf(AppVariants.Owner) ||
          domain === domainNameOf(AppVariants.Owner)) &&
        isUserInGroup(decodedToken, AppVariants.Owner)
      ) {
        changeTitleFor(AppVariants.Owner);
        changeFaviconFor(AppVariants.Owner);
        setIsAuthenticated(true);
        return true;
      } else if (
        (Url === localDebugAddressOf(AppVariants.SdcAdmin) ||
          domain === domainNameOf(AppVariants.SdcAdmin)) &&
        isUserInGroup(decodedToken, AppVariants.SdcAdmin)
      ) {
        changeTitleFor(AppVariants.SdcAdmin);
        changeFaviconFor(AppVariants.SdcAdmin);
        setIsAuthenticated(true);
        return true;
      } else if (
        (Url === localDebugAddressOf(AppVariants.SocialOperator) ||
          domain === domainNameOf(AppVariants.SocialOperator)) &&
        isUserInGroup(decodedToken, AppVariants.SocialOperator)
      ) {
        changeTitleFor(AppVariants.SocialOperator);
        changeFaviconFor(AppVariants.SocialOperator);
        setIsAuthenticated(true);
        return true;
      } else {
        // Amplify's signOut method
        Auth.signOut();

        // Clear session and cookie
        sessionStorage.clear();
        document.cookie = "foobar=; max-age=0";
        setIsAuthenticated(false);
        throw new Error("ユーザー名とパスワードが違います"); // Authenticatorに標準エラーを発生させる
      }
    } catch (error) {
      console.error("エラー" + error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (maintainanceState === null) {
      checkAuthentication();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const listener = Hub.listen(
      "auth",
      async ({ payload: { event, data } }) => {
        if (event === "signIn") {
          // signInの時にセッションストレージに値を設定してリロードする
          if (!sessionStorage.getItem("postLoginReload")) {
            sessionStorage.setItem("postLoginReload", "true");
            const authStatus = await checkAuthentication();
            console.log("authStatus" + authStatus);
            setIsAuthenticated(authStatus);
          } else {
            // リロード後はセッションストレージから値を削除する
            sessionStorage.removeItem("postLoginReload");
          }
        }
      }
    );

    // useEffectのクリーンアップ関数でlistenerを削除
    return () => Hub.remove("auth", listener);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    // ローディングスピナーや何か表示させる
    <Box display="flex" justifyContent="center" alignItems="center">
      <CircularProgress /> {/* MUIの CircularProgress コンポーネント */}
    </Box>;
  }

  if (maintainanceState !== null) {
    // メンテナンス中ページを表示する
    return (
      <MaintainanceOngoingPage
        type={maintainanceState.type}
        due={maintainanceState.due}
      />
    );
  }

  return (
    <Authenticator components={components} hideSignUp>
      <Router>
        <div style={{ backgroundColor: "#f5f5f5" }}>
          {(Url === localDebugAddressOf(AppVariants.AutolockOperator) ||
            domain === domainNameOf(AppVariants.AutolockOperator)) &&
          isAuthenticated ? (
            <Routes>
              <Route
                path="/*"
                element={
                  <>
                    <Header appVariant={AppVariants.AutolockOperator} />
                    {/* <Sidebar /> */}
                    <Routes>
                      {/* <Route path="/" /> */}
                      <Route
                        path="/"
                        element={<Navigate to="/buildings" />}
                      />{" "}
                      {/* リダイレクト */}
                      <Route
                        path="/buildings/:autoBuildingId/doors"
                        element={<AalOperatorDoorListPage />}
                      />
                      <Route
                        path="/buildings"
                        element={<AalOperatorBuildingListPage />}
                      />
                      <Route
                        path="/buildings/:autoBuildingId/doors/:autoSdcId"
                        element={<AalOperatorDoorSettingsPage />}
                      />
                      <Route
                        path="/buildings/:autoBuildingId/contractors"
                        element={<AalOperatorContractorListPage />}
                      />
                      <Route
                        path="/buildings/:autoBuildingId/contractors/new"
                        element={<AalOperatorContractorFormPage />}
                      />
                      <Route
                        path="/buildings/:autoBuildingId/contractors/:autoContractId/edit"
                        element={<AalOperatorContractorFormPage />}
                      />
                      <Route
                        path="/buildings/:autoBuildingId/contractors/:autoContractId/key-qr/:autoKeyId"
                        element={<MasterKeyQrPage />}
                      />
                      <Route
                        path="/buildings/:autoBuildingId/doors/:autoSdcId/log"
                        element={<AalOperatorDoorLogPage />}
                      />
                      {/* 404ページのルート */}
                      <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                  </>
                }
              />
            </Routes>
          ) : (Url === localDebugAddressOf(AppVariants.Fulltech) ||
              domain === domainNameOf(AppVariants.Fulltech)) &&
            isAuthenticated ? (
            <Routes>
              <Route
                path="/*"
                element={
                  <>
                    <Header appVariant={AppVariants.Fulltech} />
                    <Routes>
                      <Route path="/" element={<Navigate to="/buildings" />} />{" "}
                      {/* リダイレクト */}
                      <Route
                        path="/buildings"
                        element={<FulltechBuildingListPage />}
                      />
                      <Route
                        path="/buildings/new"
                        element={<FulltechBuildingRegistrationPage />}
                      />
                      <Route
                        path="/buildings/:autoBuildingId"
                        element={<FulltechBuildingEditPage />}
                      />
                      <Route
                        path="/buildings/:autoBuildingId/notification-log"
                        element={<FulltechAlertLogPage />}
                      />
                      <Route
                        path="/owners"
                        element={<FulltechOwnerListPage />}
                      />
                      <Route
                        path="/owners/new"
                        element={<FulltechOwnerRegistrationPage />}
                      />
                      <Route
                        path="/owners/:autoOwnerId"
                        element={<FulltechOwnerEditPage />}
                      />
                      <Route path="/doors" element={<FulltechDoorListPage />} />
                      {/* <Route path="/doors/new" element={<FulltechDoorRegistrationPage />} /> */}
                      <Route
                        path="/buildings/:autoBuildingIdInUrl/doors/new"
                        element={<FulltechDoorRegistrationPage />}
                      />
                      <Route
                        path="/doors/:autoSdcIdInUrl"
                        element={<FulltechDoorEditPage />}
                      />
                      <Route
                        path="/logs/:autoSdcId/"
                        element={<FulltechAALLogPage />}
                      />
                      <Route
                        path="/buildings/:autoBuildingId/billing-information"
                        element={<FulltechBillingInformationPage />}
                      />
                      {/* 404ページのルート */}
                      <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                  </>
                }
              />
            </Routes>
          ) : (Url === localDebugAddressOf(AppVariants.Owner) ||
              domain === domainNameOf(AppVariants.Owner)) &&
            isAuthenticated ? (
            <Routes>
              <Route
                path="/*"
                element={
                  <>
                    <Header appVariant={AppVariants.Owner} />
                    <Routes>
                      <Route path="/" element={<Navigate to="/buildings" />} />{" "}
                      {/* リダイレクト */}
                      <Route
                        path="/buildings"
                        element={<OwnerBuildingListPage />}
                      />
                      <Route
                        path="/buildings/:autoBuildingId"
                        element={<OwnerBuildingEditPage />}
                      />
                      <Route
                        path="/operators/"
                        element={<OwnerOperatorListPage />}
                      />
                      {/* 404ページのルート */}
                      <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                  </>
                }
              />
            </Routes>
          ) : (Url === localDebugAddressOf(AppVariants.SdcAdmin) ||
              domain === domainNameOf(AppVariants.SdcAdmin)) &&
            isAuthenticated ? (
            <Routes>
              <Route
                path="/*"
                element={
                  <>
                    <Header appVariant={AppVariants.SdcAdmin} />
                    <Routes>
                      <Route path="/" element={<Navigate to="/sdcs" />} />{" "}
                      {/* リダイレクト */}
                      <Route path="/sdcs" element={<HaudiSDCListPage />} />
                      <Route
                        path="/sdcs/:autoSdcId/edit"
                        element={<HaudiSDCEditPage />}
                      />
                      <Route
                        path="/logs/:autoSdcId/"
                        element={<HaudiAALLogPage />}
                      />
                      <Route path="/ota-schedules" element={<OtaListPage />} />
                      <Route
                        path="/ota-schedules/new"
                        element={<NewOtaPage />}
                      />
                      {/* 404ページのルート */}
                      <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                  </>
                }
              />
            </Routes>
          ) : (Url === localDebugAddressOf(AppVariants.SocialOperator) ||
              domain === domainNameOf(AppVariants.SocialOperator)) &&
            isAuthenticated ? (
            <Routes>
              <Route
                path="/*"
                element={
                  <>
                    <Header appVariant={AppVariants.SocialOperator} />
                    {/* <Sidebar /> */}
                    <Routes>
                      {/* <Route path="/" /> */}
                      <Route path="/" element={<Navigate to="/buildings" />} />
                      {/* リダイレクト */}
                      <Route
                        path="/buildings/:autoBuildingId/doors"
                        element={<SciOperatorDoorListPage />}
                      />
                      <Route
                        path="/buildings"
                        element={<SciOperatorBuildingListPage />}
                      />
                      <Route
                        path="/buildings/:autoBuildingId/assistance-monitor"
                        element={<SciOperatorAssistanceMonitorPage />}
                      />
                      <Route
                        path="/buildings/:autoBuildingId/doors/:autoSdcId"
                        element={<SciOperatorDoorSettingsPage />}
                      />
                      <Route
                        path="/buildings/:autoBuildingId/doors/:autoSdcId/log"
                        element={<SciOperatorDoorLogPage />}
                      />
                      {/* 404ページのルート */}
                      <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                  </>
                }
              />
            </Routes>
          ) : (
            <Routes>
              {/* Default routes */}
              {/* other routes */}
            </Routes>
          )}
        </div>
      </Router>
    </Authenticator>
  );
}

export default App;
